import { render, staticRenderFns } from "./KeyboardPopup.vue?vue&type=template&id=796b29bc&scoped=true&"
import script from "./KeyboardPopup.vue?vue&type=script&lang=js&"
export * from "./KeyboardPopup.vue?vue&type=script&lang=js&"
import style0 from "./KeyboardPopup.vue?vue&type=style&index=0&id=796b29bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796b29bc",
  null
  
)

export default component.exports